import * as React from 'react';
import { BadgeList, ComponentProps, FileUploader } from 'ui';
import { withOpenState, OpenStateInjectedProps } from 'ui/common/enhancers/with-open-state';
import { MdAttachFile } from 'react-icons/md';
import { FileUploaderProps } from 'ui/file-uploader/file-uploader';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import styles from './badge-list-file-uploader.scss';

interface BadgeListFileUploaderProps {
  textTooltip?: string;
  textHeaderTitleModal?: string;
  hideIfNoValue?: boolean;
  clickable?: boolean;
}

export type BadgeListFileUploaderComponentProps = ComponentProps & OpenStateInjectedProps & FileUploaderProps & BadgeListFileUploaderProps;
export const BadgeListFileUploaderComponent = (props: BadgeListFileUploaderComponentProps) => {
  
  const {uploadedFiles, textTooltip, textDone, textHeaderTitleModal, open, isOpen, close, hideIfNoValue, label, clickable = true} = props;
  const iconAttachments = <MdAttachFile />;
  const items = [{ value: uploadedFiles?.length, tooltip: textTooltip }];

  const closeModal = () => {
    isOpen && close();
  };
  
  const modalView =
    <ModalWrapper
      headerTitle={textHeaderTitleModal}
      btnTitle={textDone}
      onClose={closeModal}
      onDone={closeModal}>
        <FileUploader {...props}/>
    </ModalWrapper>;

  const hideComponent = hideIfNoValue && !uploadedFiles?.length;
  const onClickStyle = !clickable && styles.notClickable;

  return(<>
      {!hideComponent && <div onClick={open}>
        <BadgeList icon={iconAttachments}
          valueItems={items}
          narrow={false}
          checkIcon={false}
          className={`${onClickStyle} align-compact`}
          title={label?.text}/>
      </div> }
    {isOpen && modalView}
  </>);
};

const c = withOpenState()(BadgeListFileUploaderComponent);
export { c as BadgeListFileUploader };
